
import { BankType } from "@/models/base";
import { BankService } from "@/services";
import Vue from "vue";
import AppSelectBankType from "./SelectBankType.vue";

export default Vue.extend({
	data(){
		return {
			date: new Date(),
			amount: 0.0,
			fromBank: null as null | BankType,
			toBank: null as null | BankType,
			info: "",
			isSaving: false
		};
	},
	computed: {
		valid():boolean {
			if (this.amount == 0) {
				return false;
			}
			if (!this.fromBank){
				return false;
			}
			if (!this.toBank){
				return false;
			}
			if (this.fromBank.ID == this.toBank.ID) {
				return false;
			}
			if (this.isSaving) {
				return false;
			}
			return true;
		}
	},
	watch: {
		"fromBank"(){
			this.setInfo();
		},
		"toBank"(){
			this.setInfo();
		}
	},
	methods: {
		setInfo(){
			if (!this.fromBank) return;
			if (!this.toBank) return;
			this.info = this.$ct("transfer-from-bank-to-bank", {fromBank: this.fromBank.getName(), toBank: this.toBank.getName()}).toString();
		},
		cancel(){
			this.$emit("close");
		},
		async save(){
			if (!this.valid) return;
			if (!this.fromBank) return;
			if (!this.toBank) return;
			this.isSaving = true;
			try{
				await BankService.createTransfer({
					Date: this.date,
					Amount: this.amount,
					FromBankID: this.fromBank.ID,
					ToBankID: this.toBank.ID,
					Comment: this.info
				});
				this.$emit("saved");
				this.$emit("close");
			}catch(err){

			}finally{
				this.isSaving = false;
			}
		}
	},
	components: {
		AppSelectBankType
	},
	i18nEx: {
		componentPrefix: "components.bank"
	}
});
